import { useCallback, useEffect, useState } from "react";
import { CREATE_REQUEST_STATUS } from "@demandproai/shared";
import useSocket from "./useSocket.js";
import useAxios from "./useAxios.js";
import Constants from "../Constants";

const useCreateRequestStatusMap = ({ caseId }) => {
   const [statusByType, setStatusByType] = useState(() => new Map());
   const { getData, isLoading } = useAxios();

   useEffect(() => {
      if (!caseId) {
         setStatusByType(new Map());
         return;
      }
      getData(Constants.ApiUrl.case.getCreateRequests(caseId)).then((res) => {
         setStatusByType(seedFromCreateRequests(res?.data?.createRequests || {}));
      });
   }, [caseId, getData]);

   const handleCreateRequestUpdate = useCallback((payload) => {
      const request = payload?.request;
      if (!request?.requestType) return;
      if (caseId && String(payload.caseId) !== String(caseId)) return;
      setStatusByType((prev) => new Map(prev).set(request.requestType, request));
   }, [caseId]);

   useSocket({
      event: "createRequestNotification",
      handler: handleCreateRequestUpdate,
      enabled: !!caseId
   });

   const getStatus = useCallback((type) => statusByType.get(type)?.status, [statusByType]);

   const isComplete = useCallback(
      (type) => statusByType.get(type)?.status === CREATE_REQUEST_STATUS.COMPLETED,
      [statusByType]
   );

   const isGenerating = useCallback((type) => {
      const status = statusByType.get(type)?.status;
      return status === CREATE_REQUEST_STATUS.PENDING || status === CREATE_REQUEST_STATUS.IN_PROGRESS;
   }, [statusByType]);

   const hasFailed = useCallback(
      (type) => statusByType.get(type)?.status === CREATE_REQUEST_STATUS.FAILED,
      [statusByType]
   );

   return { statusByType, getStatus, isComplete, isGenerating, hasFailed, isLoading };
};

function seedFromCreateRequests(createRequests) {
   const map = new Map();
   Object.entries(createRequests || {}).forEach(([type, request]) => map.set(type, request));
   return map;
}

export default useCreateRequestStatusMap;
